export default __webpack_public_path__ + "static/media/ABRIDGED_Color.9358199b.png";